// Calendar - shared config
import {invert} from '@/utils/obj';

export const CALENDAR_ROUTE_DEFAULT = 'schedule';

export const ROUTES = {
    QUEUED: 'calendar-queued',
    DAY: 'calendar-day',
    WEEK: 'calendar-week',
    MONTH: 'calendar-month',
    SCHEDULE: 'calendar-schedule',
    CONFIRMED: 'calendar-confirmed',
    TRACK: 'calendar-track',
    DELETED: 'calendar-deleted',
  };

// { key: route, ... }
export const CALENDAR_ROUTES = {
    'queued': 'calendar-queued',
    'day': 'calendar-day',
    'week': 'calendar-week',
    'month': 'calendar-month',
    'schedule': 'calendar-schedule',
    'confirmed': 'calendar-confirmed',
    'track': 'calendar-track',
    'deleted': 'calendar-deleted',
//    'index': 'calendar-index', // Don't save this as a choice - it represents the absense of choice!
}

// { route: key, ... }
export const CALENDAR_KEYS = invert(CALENDAR_ROUTES);

// Local storage key name
export const CALENDAR_LAST_VIEW = 'calendar.lastView';

// If track.name == TRACK_HIDDEN, don't show the track, but *do* display the appointments in the itinerary
export const TRACK_HIDDEN = "#";

export const getCalendarLastView = () => {
    return localStorage.getItem(CALENDAR_LAST_VIEW);
};

export const setCalendarLastView = (view) => {
    if (Object.prototype.hasOwnProperty.call(CALENDAR_ROUTES, view)) {
        localStorage.setItem(CALENDAR_LAST_VIEW, view)
    }
};

export const getCalendarRoute = (defaultRoute) => {
    let view = getCalendarLastView() || defaultRoute;
    return CALENDAR_ROUTES[view];
};

export const getCalendarKeyFromRoute = (route) => {
    return CALENDAR_KEYS[route];
}
